import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxFloatUiPlacements } from 'ngx-float-ui';
import { PopperToolTipComponent } from '../../../../popper/components/popper-tool-tip/popper-tool-tip.component';
import { ExternalLinkService } from '../../../../common/services/external-link.service';

@Component({
    selector: 'ui-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
  imports: [PopperToolTipComponent, RouterLink]
})
export class FooterComponent implements OnInit {
  public popperPlacement: NgxFloatUiPlacements = NgxFloatUiPlacements.TOP;

  constructor(private externalLinkService: ExternalLinkService) { }

  ngOnInit(): void {
  }

  /**
   * The anchors carry a real href so the keyboard can reach them; this stops the
   * browser navigating so the external link confirmation still runs instead.
   */
  public openLink(event: Event, url: string): void {
    event.preventDefault();
    this.externalLinkService.open(url);
  }
}
